import { ListAiModelsUseCase } from '@/data/use-cases/ai-models-use-cases.js';
import { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { AiModelsRepositoryImpl } from '@/infra/repositories/ai-models-repository-impl.js';

const httpClient = new FetchHttpClient();
let singleton: ListAiModelsUseCase | null = null;

export const makeListAiModelsUseCase = (): ListAiModelsUseCase => new ListAiModelsUseCase(new AiModelsRepositoryImpl(httpClient));

export const getListAiModelsUseCase = (): ListAiModelsUseCase => {
    if (!singleton) {
        singleton = makeListAiModelsUseCase();
    }
    return singleton;
};
